const ADMIN_WORKSPACE_META_KEY = "offlico.admin.workspace.meta";
const ADMIN_WORKSPACE_PREVIOUS_SESSION_KEY = "offlico.admin.workspace.previous";

function readStorageItem(key) {
  if (typeof window === "undefined" || !window.localStorage) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorageItem(key, value) {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore storage failures
  }
}

function removeStorageItem(key) {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore storage failures
  }
}

function readStoredSchedulerToken() {
  const raw = readStorageItem("scheduler.token");
  if (!raw || raw === "null" || raw === "undefined") return null;
  return raw;
}

function readStoredSchedulerUser() {
  const raw = readStorageItem("scheduler.user");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function readAdminWorkspaceSessionMeta() {
  const raw = readStorageItem(ADMIN_WORKSPACE_META_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearAdminWorkspaceSessionMeta() {
  removeStorageItem(ADMIN_WORKSPACE_META_KEY);
}

export function readAdminWorkspacePreviousSession() {
  const raw = readStorageItem(ADMIN_WORKSPACE_PREVIOUS_SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed || null;
  } catch {
    return null;
  }
}

export function clearAdminWorkspacePreviousSession() {
  removeStorageItem(ADMIN_WORKSPACE_PREVIOUS_SESSION_KEY);
}

function preserveCurrentSchedulerSession() {
  const token = readStoredSchedulerToken();
  writeStorageItem(
    ADMIN_WORKSPACE_PREVIOUS_SESSION_KEY,
    JSON.stringify({
      token: token || null,
      user: readStoredSchedulerUser(),
    }),
  );
}

export function launchAdminWorkspaceSession(session, options = {}) {
  if (typeof window === "undefined" || !window.localStorage) return;
  const returnTo =
    options.returnTo ||
    `${window.location.pathname || "/admin/users/directory"}${window.location.search || ""}`;
  preserveCurrentSchedulerSession();
  writeStorageItem("scheduler.token", session.access_token);
  writeStorageItem("scheduler.user", JSON.stringify(session.user || null));
  writeStorageItem(
    ADMIN_WORKSPACE_META_KEY,
    JSON.stringify({
      returnTo,
    }),
  );
  window.dispatchEvent(
    new CustomEvent("auth:refreshed", {
      detail: { token: session.access_token, user: session.user || null },
    }),
  );
  window.location.assign("/app");
}
